<template>
  <div class="min-h-screen min-w-screen bg-porcelain">
    <main-page />
  </div>
</template>

<script>
import MainPage from './pages/MainPage'

export default {
  name: 'App',
  components: {
    MainPage
  }
}
</script>